module.exports = __webpack_public_path__ + "img/header-26.e0779ac.jpg";